module.exports = __webpack_public_path__ + "static/media/vf_mshirts_core.c40f0685.svg";